import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "BookingAccommodationTypes",
  data: () => ({
    config: {},
    title: "",
    editedItem: {}
  }),
  async mounted() {
    await this.$store.dispatch("getAccommodationTypes", {
      limit: 100,
      ignorePrincipalId: 1
    });
  },
  methods: {
    async updateSubscribedTypes(value) {
      const currentlySubscribed = this.accommodationTypes
        .filter(type => type.principals.includes(this.currentPrincipal))
        .map(type => type._id);

      const noLongerSubscribed = currentlySubscribed.filter(
        type => !value.includes(type)
      );

      const newlySubscribed = value.filter(
        type => !currentlySubscribed.includes(type)
      );
      await noLongerSubscribed.asyncForEach(async type => {
        const foundType = this.accommodationTypes.find(t => t._id === type);
        if (!foundType) return;
        foundType.principals = foundType.principals.filter(
          p => p !== this.currentPrincipal
        );
        await this.updateAccommodationType(foundType);
      });
      await newlySubscribed.asyncForEach(async type => {
        const foundType = this.accommodationTypes.find(t => t._id === type);
        if (!foundType) return;
        foundType.principals.push(this.currentPrincipal);
        await this.updateAccommodationType(foundType);
      });
    },
    async updateAccommodationType(type) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.booking_api_client_url}accommodationTypes/${type._id}`,
          type,
          { headers }
        );
        if (response.status === 200)
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich aktualisiert"
          );
        else await this.$store.dispatch("createError", response.data);
        await this.$store.dispatch("getAccommodationTypes", {
          limit: 100,
          ignorePrincipalId: 1
        });
        this.editedItem = {};
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async addNewType() {
      try {
        const headers = getTokenHeader();
        const newType = {
          title: this.title,
          principals: [this.currentPrincipal],
          deleted: false
        };
        const response = await axios.post(
          `${env.booking_api_client_url}accommodationTypes/`,
          newType,
          { headers }
        );
        if (response.status === 201)
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich hinzugefügt"
          );
        else await this.$store.dispatch("createError", response.data);
        this.title = "";
        await this.$store.dispatch("getAccommodationTypes", {
          ignorePrincipalId: 1,
          limit: 100
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async deleteType(type) {
      const confirm = await this.$confirm(
        "Möchten Sie diesen Unterkunfts-Typen wirklich löschen? ACHTUNG: Dieser ist global und wird somit für ALLE Mandanten entfernt!",
        confirmWarningConfig
      );
      if (!confirm) return;
      const headers = getTokenHeader();
      const response = await axios.delete(
        `${env.booking_api_client_url}accommodationTypes/${type._id}`,
        { headers }
      );
      if (response.status === 200)
        await this.$store.dispatch("createSuccess", "Erfolgreich gelöscht");
      else await this.$store.dispatch("createError", response.data);
      await this.$store.dispatch("getAccommodationTypes", {
        ignorePrincipalId: 1,
        limit: 100
      });
    }
  },
  computed: {
    accommodationTypes() {
      return this.$store.state.accommodationTypes;
    },
    subscribedTypes() {
      return this.accommodationTypes.filter(type =>
        type.principals.includes(this.currentPrincipal)
      );
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
